<template>
  <div class="xitongxiaoxi">
    <div class="xt-title">我的订单</div>
    <div class="xt-list" ref="listContainer" @scroll="handleScroll">
      <div class="dd-list-item" v-for="(item, index) in list" :key="item.id || index">
		 <div class="dd-list-item-top">
		 	<div class="dd-list-item-top-left">
		 		<img src="../../assets/image/zhibo_14@2x.png" alt=""/>
				<span>{{item.liveInfo.name}}</span>
		 	</div>
			<span class="dd-list-item-top-span">{{item.orderStatusName}}</span>
		 </div> 
		 <div class="dd-list-item-goods">
		 	<img :src="item.goodsInfo.mediasList[0].uri" alt="" @error="handleImgError"/>
			<div class="dd-list-item-goods-content">
				<div class="dd-list-item-goods-content-name">{{item.goodsInfo.goodsName}}</div>
				<div class="dd-list-item-goods-content-price">
					<div class="dd-list-item-goods-content-price-left">
						<!-- <span class="dd-list-item-goods-content-price-left-span">US</span> -->
						<span class="dd-list-item-goods-content-price-left-span1">USDN{{item.goodsInfo.specificationList[0].price}}</span>
					</div>
					<div class="dd-list-item-goods-content-price-right">x{{item.number}}</div>
				</div>
			</div>
		 </div>
		 <div class="dd-list-item-bottom">{{$t('all.dingdanjine')}}：USDN{{item.orderPrice}}</div>
		 <div class="dd-list-item-no">
		 	<span class="dd-list-item-no-span">{{$t('all.dingdanbianhao')}}</span>
		 	<span class="dd-list-item-no-span1">{{item.orderOn}}</span>
		 </div>
		 <div class="dd-list-item-no">
		 	<span class="dd-list-item-no-span">{{$t('all.chuangjianshijian')}}</span>
		 	<span class="dd-list-item-no-span1">{{item.createTime}}</span>
		 </div>
      </div>
      <!-- 当没有更多数据且列表为空时，显示空状态 -->
      <kong v-if="!hasMore && list.length === 0"></kong>
    </div>
  </div>
</template>

<script>
import kong from "../kong/kong.vue";
import { getUserOrderList } from "@/api/zhibo";

export default {
  name: 'xitongxiaoxi',
  components: {
    kong
  },
  data() {
    return {
      queryParams: {
        page: 1,
        size: 10,
      },
      list: [],
      hasMore: true,
      // 1. 新增一个加载状态锁，防止重复请求
      isLoading: false,
	  defaultGoodsImg: 'https://ahhzy.oss-cn-hangzhou.aliyuncs.com/feedback/images/1768282483370_nzuet3anc9h.png'
    };
  },
  mounted() {
    this.getUserOrderList();
  },
  methods: {
	handleImgError(e) {
	    // e.target 指向加载失败的 img 元素，替换其 src 为默认图片
	    e.target.src = this.defaultGoodsImg;
	    // 可选：防止默认图片也加载失败时无限触发 onerror 事件
	    e.target.onerror = null;
	},
    // 获取订单列表
    async getUserOrderList() {
      // 2. 如果正在加载或没有更多数据，则直接返回
      if (this.isLoading || !this.hasMore) {
        return;
      }

      try {
        // 3. 发起请求前，将加载状态设为 true
        this.isLoading = true;

        const response = await getUserOrderList(this.queryParams);
        const newList = response.rows || [];

        if (this.queryParams.page === 1) {
          this.list = newList;
        } else {
          this.list = [...this.list, ...newList];
        }

        const totalPages = Math.ceil((response.total || 0) / this.queryParams.size);
        this.hasMore = this.queryParams.page < totalPages;

      } catch (error) {
        console.error("获取系统消息列表失败:", error);
      } finally {
        // 4. 请求结束（无论成功或失败），将加载状态恢复为 false
        this.isLoading = false;
      }
    },

    // 滚动事件处理函数
    handleScroll() {
      // 同样增加 isLoading 判断，防止在请求期间触发
      if (this.isLoading || !this.hasMore) {
        return;
      }

      const container = this.$refs.listContainer;
      // 判断滚动条是否到达底部（或接近底部）
      const isAtBottom = container.scrollTop + container.clientHeight >= container.scrollHeight - 10;

      if (isAtBottom) {
        console.log("滚动到底部，准备加载第", this.queryParams.page + 1, "页");
        this.queryParams.page++;
        this.getUserOrderList();
      }
    }
  }
};
</script>

<style scoped lang="scss">
	@import "./wodedingdan.css";
</style>


// WEBPACK FOOTER //
// wodedingdan.vue?35c9a7b6